// Delay helper function
function wait(ms){
	var start = new Date().getTime();
	var end = start;
	while(end < start + ms) {
		end = new Date().getTime();
 }
}

// Slice Array
// https://www.30secondsofcode.org/js/s/nth-array-element/
const nthElement = (arr, n = 0) => (n === -1 ? arr.slice(n) : arr.slice(n, n + 1))[0];

// Return site URL based on site ID
let getSiteUrl = (number) => {
	let sites = document.querySelectorAll('.footer__sites li');
	let goTo = ""
	sites.forEach((el) => {
		let dataId = el.dataset.id;
		if(dataId == number) {
			goTo = el.innerHTML;
		}
	});
	return goTo;
};

// Converts JSON Raw data to array
// https://stackoverflow.com/questions/14528385/how-to-convert-json-object-to-javascript-array
function json2array(json){
	var result = [];
	var keys = Object.keys(json);
	keys.forEach(function(key){
			result.push(json[key]);
	});
	return result;
}

// Global SVG Icon
let iconSvg = 'M 20 0 C 8.980469 0 0 8.980469 0 20 C 0 31.019531 8.980469 40 20 40 C 31.019531 40 40 31.019531 40 20 C 40 8.980469 31.019531 0 20 0 Z M 20 4.617188 C 28.523438 4.617188 35.382812 11.476562 35.382812 20 C 35.382812 28.523438 28.523438 35.382812 20 35.382812 C 11.476562 35.382812 4.617188 28.523438 4.617188 20 C 4.617188 11.476562 11.476562 4.617188 20 4.617188 Z M 20 4.617188 "></path><path d="M 16.535156 10.992188 C 16.535156 10.992188 16.535156 10.992188 16.53125 10.992188 C 15.949219 10.992188 15.417969 11.226562 15.035156 11.609375 C 14.652344 11.992188 14.414062 12.523438 14.414062 13.109375 C 14.414062 13.695312 14.652344 14.226562 15.035156 14.609375 L 20.425781 20 L 15.035156 25.390625 C 14.652344 25.773438 14.414062 26.304688 14.414062 26.890625 C 14.414062 27.476562 14.652344 28.003906 15.035156 28.386719 C 15.417969 28.773438 15.949219 29.011719 16.535156 29.011719 C 17.121094 29.011719 17.652344 28.773438 18.035156 28.390625 L 24.925781 21.496094 C 25.308594 21.113281 25.542969 20.582031 25.542969 20 C 25.542969 19.414062 25.304688 18.882812 24.921875 18.5 L 18.035156 11.609375 C 17.652344 11.226562 17.121094 10.992188 16.539062 10.992188 C 16.535156 10.992188 16.535156 10.992188 16.535156 10.992188 Z M 16.535156 10.992188';

let iconMarker = 'M 20 24.445312 C 15.089844 24.445312 11.109375 20.464844 11.109375 15.554688 C 11.109375 10.648438 15.089844 6.667969 20 6.667969 C 24.910156 6.667969 28.890625 10.648438 28.890625 15.554688 C 28.890625 20.464844 24.910156 24.445312 20 24.445312 Z M 20 22.222656 C 23.683594 22.222656 26.667969 19.238281 26.667969 15.554688 C 26.667969 11.875 23.683594 8.890625 20 8.890625 C 16.316406 8.890625 13.332031 11.875 13.332031 15.554688 C 13.332031 19.238281 16.316406 22.222656 20 22.222656 Z M 20.753906 39.707031 C 20.328125 40.097656 19.671875 40.097656 19.246094 39.707031 C 9.410156 30.625 4.445312 22.605469 4.445312 15.554688 C 4.445312 6.964844 11.410156 0 20 0 C 28.589844 0 35.554688 6.964844 35.554688 15.554688 C 35.554688 22.605469 30.589844 30.625 20.753906 39.707031 Z M 33.332031 15.554688 C 33.332031 8.191406 27.363281 2.222656 20 2.222656 C 12.636719 2.222656 6.667969 8.191406 6.667969 15.554688 C 6.667969 21.671875 11.082031 28.96875 20 37.371094 C 28.917969 28.96875 33.332031 21.671875 33.332031 15.554688 Z M 33.332031 15.554688 ';

let iconPhone = 'M 8.65625 26.308594 C 12.324219 30.703125 16.824219 34.269531 21.933594 36.792969 L 22.171875 36.898438 C 24.367188 38.054688 26.929688 38.851562 29.644531 39.128906 L 29.734375 39.136719 C 29.917969 39.136719 30.09375 39.152344 30.273438 39.152344 C 30.332031 39.152344 30.394531 39.152344 30.460938 39.152344 C 32.316406 39.152344 33.980469 38.347656 35.128906 37.070312 L 35.132812 37.0625 C 35.144531 37.050781 35.15625 37.039062 35.164062 37.027344 L 35.164062 37.023438 C 35.65625 36.457031 36.15625 35.9375 36.679688 35.449219 L 36.691406 35.4375 C 37.0625 35.078125 37.445312 34.707031 37.8125 34.328125 C 38.589844 33.621094 39.078125 32.609375 39.078125 31.480469 C 39.078125 30.34375 38.582031 29.324219 37.800781 28.621094 L 37.796875 28.621094 L 33.023438 23.847656 C 32.335938 23.078125 31.351562 22.585938 30.25 22.554688 L 30.242188 22.554688 C 29.125 22.585938 28.125 23.070312 27.417969 23.832031 L 24.578125 26.675781 C 24.316406 26.523438 24.042969 26.390625 23.792969 26.261719 C 23.4375 26.09375 23.152344 25.933594 22.875 25.761719 L 22.917969 25.785156 C 20.136719 23.960938 17.765625 21.792969 15.78125 19.304688 L 15.734375 19.246094 C 14.796875 18.128906 13.984375 16.855469 13.34375 15.488281 L 13.296875 15.378906 C 14.042969 14.703125 14.742188 14 15.417969 13.308594 C 15.65625 13.0625 15.902344 12.816406 16.148438 12.570312 C 16.929688 11.855469 17.425781 10.847656 17.46875 9.722656 L 17.46875 9.714844 C 17.429688 8.578125 16.929688 7.570312 16.152344 6.859375 L 16.148438 6.855469 L 13.78125 4.492188 C 13.503906 4.210938 13.242188 3.941406 12.972656 3.664062 C 12.449219 3.125 11.902344 2.570312 11.363281 2.070312 C 10.65625 1.332031 9.667969 0.867188 8.570312 0.847656 L 8.566406 0.847656 C 7.457031 0.871094 6.460938 1.339844 5.742188 2.074219 L 5.742188 2.078125 L 2.769531 5.046875 C 1.742188 6.050781 1.070312 7.410156 0.953125 8.925781 L 0.949219 8.949219 C 0.9375 9.164062 0.933594 9.414062 0.933594 9.667969 C 0.933594 11.699219 1.34375 13.632812 2.089844 15.394531 L 2.054688 15.296875 C 3.699219 19.535156 5.929688 23.183594 8.691406 26.355469 Z M 2.890625 9.117188 C 2.972656 8.054688 3.441406 7.109375 4.152344 6.417969 L 7.109375 3.464844 C 7.476562 3.070312 7.988281 2.816406 8.5625 2.789062 L 8.566406 2.789062 C 9.140625 2.816406 9.644531 3.078125 9.996094 3.476562 C 10.527344 3.96875 11.027344 4.484375 11.570312 5.03125 C 11.839844 5.3125 12.117188 5.589844 12.394531 5.882812 L 14.757812 8.246094 C 15.183594 8.609375 15.460938 9.132812 15.503906 9.722656 L 15.503906 9.730469 C 15.460938 10.324219 15.183594 10.847656 14.761719 11.210938 L 14.757812 11.214844 C 14.511719 11.460938 14.265625 11.714844 14.019531 11.960938 C 13.28125 12.707031 12.59375 13.410156 11.828125 14.085938 L 11.789062 14.125 C 11.472656 14.410156 11.273438 14.824219 11.273438 15.285156 C 11.273438 15.5 11.316406 15.710938 11.398438 15.898438 L 11.394531 15.886719 C 11.394531 15.910156 11.410156 15.925781 11.417969 15.949219 C 12.175781 17.683594 13.109375 19.175781 14.226562 20.511719 L 14.203125 20.480469 C 16.363281 23.203125 18.890625 25.511719 21.734375 27.375 L 21.855469 27.449219 C 22.136719 27.628906 22.480469 27.820312 22.835938 27.992188 L 22.902344 28.023438 C 23.253906 28.191406 23.542969 28.351562 23.816406 28.523438 L 23.777344 28.5 L 23.863281 28.546875 C 24.085938 28.667969 24.351562 28.742188 24.632812 28.746094 C 25.101562 28.730469 25.523438 28.527344 25.820312 28.207031 L 28.789062 25.238281 C 29.148438 24.832031 29.660156 24.566406 30.234375 24.53125 L 30.238281 24.53125 C 30.804688 24.566406 31.300781 24.832031 31.640625 25.234375 L 36.425781 30.019531 C 36.859375 30.371094 37.132812 30.90625 37.132812 31.503906 C 37.132812 32.113281 36.851562 32.65625 36.40625 33.007812 L 36.402344 33.011719 C 36.0625 33.367188 35.722656 33.707031 35.347656 34.066406 C 34.765625 34.609375 34.226562 35.171875 33.714844 35.761719 L 33.6875 35.789062 C 32.886719 36.679688 31.730469 37.234375 30.445312 37.234375 C 30.390625 37.234375 30.332031 37.234375 30.277344 37.234375 L 30.285156 37.234375 C 30.148438 37.234375 30.003906 37.234375 29.871094 37.21875 C 27.332031 36.949219 25.015625 36.222656 22.925781 35.121094 L 23.03125 35.171875 C 17.941406 32.667969 13.652344 29.273438 10.210938 25.148438 L 10.164062 25.085938 C 7.578125 22.121094 5.460938 18.664062 3.96875 14.890625 L 3.886719 14.648438 C 3.25 13.179688 2.878906 11.46875 2.878906 9.671875 C 2.878906 9.476562 2.882812 9.28125 2.894531 9.089844 Z M 2.890625 9.117188 ';

// Accordion
let accordions = document.querySelectorAll('.accordion');

function deactivateSiblings() {
	for (const accordion of accordions) {
		accordion.classList.remove('active');
	}
}

for (let i = 0; i < accordions.length; i++) {
	let accordion = accordions[i];
	let accordionBtn = accordion.querySelector('.accordion__header');
	accordionBtn.addEventListener('click', function() {
		if (accordion.classList.contains('active')) {
			accordion.classList.remove('active');
		} else {
			deactivateSiblings();
			accordion.classList.add('active');
		}
	});
}

// Share
let shares = document.querySelectorAll('.share');

let toggleAllOvfs = () => {
	shares.forEach((el) => el.classList.remove('active'));
}

if (typeof shares != 'undefined' && shares != null) {
	for (let i=0;i<shares.length;i++) {
		let share = shares[i];
		let shareBtn = share.querySelector('.share__btn');
		shareBtn.addEventListener('click', (e) => {
			let shareParent = shareBtn.parentElement;
			if(shareParent.classList.contains('active')) {
				toggleAllOvfs();
			} else {
				toggleAllOvfs();
				shareParent.classList.add('active');
			};
		});
	}
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

let baseUrl = window.location.origin;

const navbarMenu = document.querySelector('.js-header__nav');
const burgerMenu = document.querySelector('.js-header__trigger');
const overlayMenu = document.querySelector('.header__overlay');
const menuItems = document.querySelectorAll('.menu-item a');
const childrenedLink = document.querySelectorAll('.menu-item-has-children > a');

// Menu title
for(let i = 0; i < menuItems.length; i++ ) {
  let menuItem = menuItems[i];
	var innerContent = menuItem.innerHTML;
	menuItem.setAttribute("title", innerContent);
}

// insertAfter
function insertAfter(newNode, existingNode) {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Guess what it does
function removeHash() { 
  history.replaceState(null, null, ' ');
}

// Insert button after link with children
let injectAfter = (newNode, existingNode) => {
	existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Remove "active" class for menu-has-children siblings
let disableAllSiblings = (currIndex) => {
  for(let i = 0; i < childrenedLink.length; i++) {
		if(i != currIndex) {
			childrenedLink[i].parentNode.classList.remove('active');
		}
	}
}

// Add button to sub menu
function subMenu() {

  for(let i = 0; i < childrenedLink.length; i++) {
		let thisLink = childrenedLink[i];
		let btn = document.createElement('button');
		btn.classList.add('menu-toggler');
		injectAfter(btn, thisLink);
		btn.addEventListener('click', function() {
			let parent = btn.parentNode;
			disableAllSiblings(i);
			parent.classList.toggle('active');
		});
  }

}

subMenu();

// Toggle Menu Function
burgerMenu.addEventListener('click', toggleMenu);

function toggleMenu() {
	navbarMenu.classList.toggle('active');
	overlayMenu.classList.toggle('active');
	burgerMenu.classList.toggle('active');
}

// Function to compare job filter values
// let filterValues = (src, target) => {
// 	for (let i=0; i<src.length; i++) {
// 		if(target.includes(src[i])) {
// 			return true;
// 		} else {
// 			return false;
// 		};
// 	}
// };

// Function to modify Job application form
let jsJobApplication = () => {

	let jsForm = document.querySelector('.js-form');

	if (typeof(jsForm) != 'undefined' && jsForm != null) {

		let object = document.querySelector('.awsm-job-form-group:nth-child(4) input');

		if (typeof(object) != 'undefined' && object != null) {
			let ref = jsForm.getAttribute('data-ref');
			object.value = 'Objet : Référence n°' + ref;
			object.readOnly = true;
		}
	
		let typeArr = (el) => {
			el.addEventListener('input', (event) => {
				if(firstName.value != '' && lastName.value != '') {
					result = firstName.value + ' ' + lastName.value;
					fullName.value = result;
				} else {
					fullName.value = '';
				}
			});
		}

	}

}

let togglePopup =() => {
	let popUp = document.querySelector('.popup');

	if (typeof(popUp) != 'undefined' && popUp != null) {

		let popupTrigger = document.querySelector('.js-popup');
		let popupBtn = document.querySelector('.popup__btn');

		popupTrigger.addEventListener('click', () => {
			popUp.classList.add('active');
			setTimeout(() => {
				popUp.classList.add('visible');
			}, 300);
		});

		popupBtn.addEventListener('click', () => {
			popUp.classList.remove('visible');
			setTimeout(() => {
				popUp.classList.remove('active');
			}, 500);
		});

	}

}

// Load news on click
let revealNews = () => {

	let news = document.querySelector('.js-news');

	if (typeof(news) != 'undefined' && news != undefined) {

		let newsPost = news.querySelectorAll('.news__article');
		let newsBtn = document.querySelector('.js-news-btn');

		for(let i=0; i<newsPost.length; i++) {
			if(i > 3) {
				newsPost[i].classList.add('hidden');
				newsPost[i].classList.add('invisible');
			}
		}

		let displaySlides = () => {
			let newsHidden = document.querySelectorAll('.news__article.invisible');
			for(let i=0; i<newsHidden.length; i++) {
				if(i < 3) {
					newsHidden[i].classList.remove('hidden');
					setTimeout(() => {
						newsHidden[i].classList.remove('invisible');
					}, "500");
				}
			}
		}

		newsBtn.addEventListener("click", () => {
			displaySlides();
		});

	}

}

// toggle Contact Form accordion
let toggleContact = () => {

	let contactForm = document.querySelector('.js-contact');

	if (typeof(contactForm) != 'undefined' && contactForm != undefined) {
	
		let contactBtn = document.querySelectorAll('.js-contact-btn')

		for(let i=0; i<contactBtn.length; i++) {
			contactBtn[i].addEventListener("click", () => {
				contactForm.classList.add('active');
			});
		}

	}

}


// isotope.js for products filtering
let setProductIsotope = () => {

	let grid = document.querySelector('.prods__grid');

	if (typeof(grid) != 'undefined' && grid != undefined) {

		/** VARIABLES **/

		// Search bar
		let quicksearch = document.querySelector('.quicksearch');

		// Isotope Grid
		let iso = new Isotope( grid, {
			itemSelector: '.prods__block',
			layoutMode: 'fitRows',
		});

		// Checkboxes
		let filters = document.querySelectorAll('.prods__filter input[type=checkbox]');
		let filterArr = [];

		/** ISOTOPE CHECKBOXES **/

		for (let i=0;i<filters.length;i++) {
			let filter = filters[i];
			filter.addEventListener('change', (e) => {

				// Clear search bar on check
				quicksearch.value = "";

				// Get value of checked element
				let filterValue = e.target.getAttribute('data-filter');

				// If checked, remove value from array
				if (e.target.checked === false) {
					const index = filterArr.indexOf(filterValue);
					filterArr.splice(index, 1);
				// Else, add it to array
				} else {
					filterArr.push(filterValue);
				}

				// Convert array to comma-separated string
				let comma_separated = filterArr.join(", ")

				// Filter content depending of checked values (Isotope)
				iso.arrange({
					filter: comma_separated
				})

			})
		}

		/** ISOTOPE SEARCHBAR **/
		/** https://codepen.io/desandro/pen/ELyQMx **/

		// quick search regex
		var qsRegex;

		// use value of search field to filter
		quicksearch.addEventListener( 'keyup', debounce_search( function() {

			// Clear checkboxes on search
			filters.forEach((filter) => filter.checked = false);
			filterArr = [];

			// Regex to ignore capitlized letters
			qsRegex = new RegExp( quicksearch.value, 'gi' );

			iso.arrange({
				// for whatever reason, the function below needs 2 arguments
				// https://stackoverflow.com/questions/61493072/isotope-filter-function-returning-0-for-element-item
				filter: function(elArg1, elArg2) {
					return qsRegex ? elArg2.querySelector('.prods__text').innerHTML.match( qsRegex ) : true;
				}
			});

		}, 200 ) );

		// debounce so filtering doesn't happen every millisecond
		function debounce_search( fn, threshold ) {
			var timeout;
			threshold = threshold || 100;
			return function debounced() {
				clearTimeout( timeout );
				var args = arguments;
				var _this = this;
				function delayed() {
					fn.apply( _this, args );
				}
				timeout = setTimeout( delayed, threshold );
			};
		}

	}

}

// isotope.js for products filtering
let setJobIsotope = () => {

	let grid = document.querySelector('.js-jobs__content');

	if (typeof(grid) != 'undefined' && grid != undefined) {

		/** VARIABLES **/

		// Isotope Grid
		let iso = new Isotope( grid, {
			itemSelector: '.job',
			layoutMode: 'vertical',
		});

		// Smooth height change function
		iso.on( 'layoutComplete', function( laidOutItems ) {
			let gridHeight = grid.style.height;
			grid.style.maxHeight = gridHeight;
		} );

		// Checkboxes
		let filters = document.querySelectorAll('.js-jobs__filters input[type=checkbox]');
		let filterArr = [];

		/** ISOTOPE CHECKBOXES **/

		for (let i=0;i<filters.length;i++) {
			let filter = filters[i];
			filter.addEventListener('change', (e) => {

				// Get value of checked element
				let filterValue = e.target.getAttribute('data-filter');
				
				// If checked, remove value from array
				if (e.target.checked === false) {
					const index = filterArr.indexOf(filterValue);
					filterArr.splice(index, 1);
				// Else, add it to array
				} else {
					filterArr.push(filterValue);
				}

				// Convert array to comma-separated string
				let comma_separated = filterArr.join(", ")

				// Filter content depending of checked values (Isotope)
				iso.arrange({
					filter: comma_separated
				})

			})
		}
	}

}

// Toggle poroducs sidebar (mobile)
let toggleProductsSidebar = () => {

	let sidebar = document.querySelector('.prods__sidebar');

	if (typeof(sidebar) != 'undefined' && sidebar != undefined) {

		if((window.innerWidth < 1024)) {

			let sidebarBtn = document.querySelector('.prods__btn');
			let sidebarHeight = sidebar.querySelector('.prods__inner').offsetHeight;
			sidebar.style.paddingBottom = "0px";

			sidebarBtn.addEventListener('click', () => {
				if(sidebarBtn.classList.contains('active')) {
					sidebarBtn.classList.remove('active');
					sidebar.style.paddingBottom = "0px";
				} else {
					sidebarBtn.classList.add('active');
					sidebar.style.paddingBottom = sidebarHeight + "px";
				};
			});

		} else {

			sidebar.style.paddingBottom = "0px";

		}

	}

}

// Toggle products sidebar - resize
let resizeProductsSidebar = debounce(function() {
	toggleProductsSidebar();
}, 250);

window.addEventListener("resize", resizeProductsSidebar);

let toggleJobsFilter = () => {

	let filter = document.querySelector('.js-jobs__filters');

	if (typeof(filter) != 'undefined' && filter != null) {

		let jobBtns = document.querySelectorAll('.js-jobs__btn');

		let closeBtns = () => {
			jobBtns.forEach((el) => { el.parentNode.classList.remove('active') });
		}

		for(let i=0;i<jobBtns.length;i++) {
			let btn = jobBtns[i];
			btn.addEventListener('click', (e) => {
				if(e.target.parentNode.classList.contains('active')) {
					closeBtns();
				} else {
					closeBtns();
					e.target.parentNode.classList.add('active');
				}
			});
		}

	}

}

// Single product share/apply buttons

let jobShareApply = () => {

	let applyBtn = document.querySelector('.js-job-footer-apply');

	if (typeof(applyBtn) != 'undefined' && applyBtn != null) {

		let sharePanel =  document.querySelector('.share');
		let shareBtn = document.querySelector('.js-job-footer-share');
		let applyPopUp = document.querySelector('.popup');

		shareBtn.addEventListener('click', () => {
			if (!sharePanel.classList.contains('active')) {
				sharePanel.classList.add('active');
			};
		});

		applyBtn.addEventListener('click', () => {
			applyPopUp.classList.add('active');
			setTimeout(() => {
				applyPopUp.classList.add('visible');
			}, 300);
		});

	}

}

// JOB ISOTOPE
// https://stackoverflow.com/questions/17553076/isotope-combination-filtering-multiple-selection

class Metafizzy {

	constructor(isotope) {
			this.isotope = isotope; // pass Isotope
			this.filters = {};
	}

	run(optionsContainerID, filterDisplayID) {
			let options = document.getElementById(optionsContainerID);
			let filterDisplay = document.getElementById(filterDisplayID);
			let jobsGrid = document.querySelector('.js-jobs__content');
			let jobsMessage = document.querySelector('.js-jobs__message');
			
			// do stuff when checkbox change
			options.addEventListener('change', (event) => {
					let inputElem = event.target;

					this.manageInputElement(inputElem);
					
					let comboFilter = this.getComboFilter(this.filters);
					
					this.isotope.arrange({ filter: comboFilter });

					let gridHeight = jobsGrid.style.height;
					if(gridHeight == '0px') {
						jobsMessage.classList.add('active');
					} else {
						jobsMessage.classList.remove('active');
					}
					
					//console.log(comboFilter); // uncomment to see the current filter output
			});

	}

	manageInputElement(inputElem) {
			let _this = this;
			// get the closest matching parent, and it's attribute value
			let parent = inputElem.closest('.iso-option-set');
			let group = parent.getAttribute('data-group');
			// create array for filter group, if not there yet
			let filterGroup = this.filters[group];
			if ( ! filterGroup) {
					filterGroup = this.filters[group] = [];
			}
			
			let isAll = inputElem.classList.contains('iso-all');
			// reset filter group if the all box was checked
			
			if (inputElem.type === 'checkbox') {
					this.doCheckBoxStuff(inputElem, parent, group, filterGroup, isAll)
			} else if (inputElem.type === 'range') {
					console.log('is element type "range"')
			}
			
	}

	doCheckBoxStuff(checkbox, parent, group, filterGroup, isAll) {
			if (isAll) {
					delete this.filters[group];
					if ( ! checkbox.checked) {
							checkbox.checked = true;
					}
			}
			// index of
			let hasCheckboxValue = filterGroup.includes(checkbox.value);
			let index = hasCheckboxValue ? 1 : -1;
			
			if (checkbox.checked) {
					let selector = isAll ? 'input' : 'input.iso-all';
					let allButton = parent.querySelector(selector);
					if (allButton) {
							allButton.checked = false;
					}
					
					if ( ! isAll && hasCheckboxValue === false) {
							// add filter to group
							this.filters[group].push(checkbox.value);
					}
					
			} else if ( ! isAll) {
					// remove filter from group
					// gets the index of the property by value
					function findWithAttr(array, value) {
							for(let i = 0; i < array.length; i += 1) {
									if(array[i] === value) {
											return i;
									}
							}
							return -1;
					}
					let startIndex = findWithAttr(this.filters[ group ], checkbox.value)
					
					this.filters[ group ].splice( startIndex, 1 );
					// if all boxes unchecked, check the iso-all
					if ( ! parent.querySelectorAll('input:not(.iso-all):checked').length) {
							parent.querySelector('input.iso-all').checked = true;
					}
			}
	}

	getComboFilter(filters) {
			let i = 0;
			let comboFilters = [];
			let message = [];
			
			for (let prop in filters) {
					message.push(filters[prop].join(' '));
					let filterGroup = filters[prop];
					// skip to next filter group if it doesn't have any values
					if ( ! filterGroup.length) {
							continue;
					}
					if (i === 0) {
							// copy to new array
							comboFilters = filterGroup.slice(0);
					} else {
							let filterSelectors = [];
							// copy to fresh array
							let groupCombo = comboFilters.slice(0); // [ A, B ]
							// merge filter Groups
							for (let k = 0, len3 = filterGroup.length; k < len3; k++) {
									for (let j = 0, len2 = groupCombo.length; j < len2; j++) {
											filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
									}
									
							}
							// apply filter selectors to combo filters for next group
							comboFilters = filterSelectors;
					}
					i++;
			}
			
			let comboFilter = comboFilters.join(', ');
			return comboFilter;
		}

}

let toggleContactMap = () => {

	let mapContainer = document.querySelector('.contact-blocks__map');

	if (typeof(mapContainer) != 'undefined' && mapContainer != null) {

		let mapH = mapContainer.offsetHeight;
		mapContainer.style.maxHeight = '0px';
		let mapBtn = document.querySelector('.contact-blocks__block--has-map .contact-blocks__btn .btn__link');

		mapBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if(!e.target.classList.contains('active')) {
				e.target.classList.add('active');
				mapContainer.style.maxHeight = mapH + 'px';
			} else {
				e.target.classList.remove('active');
				mapContainer.style.maxHeight = '0px';
			};
		});



	}

}

let jobsCarousel = () => {

			const jobsContainer = document.querySelector('.job-carousel');

			if (typeof(jobsContainer) != 'undefined' && jobsContainer != null) {

				// JOBS SLIDER
				let jobsSlider = jobsContainer.querySelector('.splide-jobs');
				let jobsSplide = new Splide( jobsSlider, {
					type: 'loop',
					arrows: true,
					arrowPath: iconSvg,
					pagination: false,
					perPage: 1,
					perMove: 1,
					focus: 0,
					autoplay: true,
					interval: 4000,
					speed: 1000,
					snap: true,
					easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
					mediaQuery: "min",
					breakpoints: {
						768: {
							perPage: 2,
							perMove: 2,
							gap: "20px"
						},
						1024: {
							perPage: 3,
							perMove: 3,
							gap: "40px"
						}
					}
				} );
				jobsSplide.mount();

				// FETCH POSTS
				const postsShown = 100;
				let count = 0;
				let siteId = jobsContainer.getAttribute('data-id');
				let siteEspaceAgri = jobsContainer.getAttribute('data-esagri').replace("http://", "https://");				;
				let siteManu = jobsContainer.getAttribute('data-manu').replace("http://", "https://");	
				let siteGroupe = jobsContainer.getAttribute('data-groupe').replace("http://", "https://");	
				let themeUrl = jobsContainer.getAttribute('data-theme');
				let logoGroupe = themeUrl + '/assets/images/logo_gb_horiz.png';
				let logoEspaceAgri = themeUrl + '/assets/images/logo_espace_agri.png';
				let logoAgri = themeUrl + '/assets/images/logo_agri_horiz.png';
				let logoManu = themeUrl + '/assets/images/logo_manu_horiz.png';

				//Site-specific variables
				let currSite;
				let logo;

				// Fetch functions
				let fetchAsync = async () => {
					const response = await fetch(siteGroupe + `/wp-json/awsm_job_openings/all-posts`);
					if(response.ok == true) {
						fetchFunction();
					} else {
						console.log('oops, erreur !')
					};
				}

				let fetchFunction = () => {
					fetch(siteGroupe + `/wp-json/awsm_job_openings/all-posts`)
					.then((response) => response.json())
					.then((data) => {

					const newData = chunkArray(data, postsShown);
					const currentChunk = newData[count];
					
					currentChunk.forEach((key, index) => {

						// JSON Variables
						const postSite = currentChunk[index].site;
						const postSiteArr = json2array(postSite);
						const postSlug = currentChunk[index].slug;
						const postTitle = currentChunk[index].title;
						const postDate = currentChunk[index].date;
						const postTaxosArr = json2array(currentChunk[index].taxo);
						const postType = postTaxosArr[1];
						const postAddr = postTaxosArr[2];
						const postEntity = currentChunk[index].entity;

						// Define Entity-specific data
						if(postSiteArr.includes(2)) {
							currSite = siteEspaceAgri;
							logo = logoEspaceAgri;
						} else if (postSiteArr.includes(3)) {
							currSite = siteManu;
							logo = logoManu;
						} else {
							currSite = siteGroupe;
							if(postEntity == "bernard-agriculture") {
								logo = logoAgri;
							} else {
								logo = logoGroupe;
							}
						}

						const slide = `<div class="splide__slide">
							<div class="splide__slide__inner">
								<a class="job-carousel__link" href="${currSite}emploi/${postSlug}/">
									<p class="job-carousel__title">${postTitle}<p>
									<p class="job-carousel__date">Publiée le ${postDate}</p>
									<figure class="job-carousel__figure">
										<img src="${logo}" >
									</figure>
									<p class="job-carousel__bottom">
										<span class="job-carousel__location">${postAddr}</span>
										<span class="job-carousel__type">${postType}</span>
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28px" height="28px" viewBox="0 0 40 40" version="1.1"><path d="${iconSvg}"></path></svg>
									</p>
								</a>
							</div>
						</div>`;

						if(siteId == 2 && postSiteArr.includes(2) || siteId == 3 && postSiteArr.includes(3)) {
							jobsSplide.add( slide );
						} else if(siteId == 1) {
							jobsSplide.add( slide );
						}

					});

					}).then(function() {
			
					})
					.catch((err) => {
						console.log("Something went wrong!", err);
					});

				}

				fetchAsync();

			}
}

// DOM load
document.addEventListener("DOMContentLoaded", function(event) {

	// Toggle Jobs Filter
	toggleJobsFilter();

	// Toggle poroducs sidebar (mobile)
	toggleProductsSidebar();

	// Isotope.js for products filtering
	setProductIsotope();

	// Isotope.js for products filtering
	// setJobIsotope();

	// Toggle Contact Form accordion
	toggleContact();

	// Toggle Contact Form accordion
	toggleContactMap();

	// Load news on click
	// revealNews();

	// Function to display popup
	togglePopup();

	// Single product share/apply buttons
	jobShareApply();

	// Function to modify Job application form
	jsJobApplication();

	// jobs Carousel
	jobsCarousel();

	// PARTNERS SLIDER
	let sliderPartners = document.querySelector('.splide-partners');

	if (typeof sliderPartners != 'undefined' && sliderPartners != null) {
		let partnersBtnNext = document.querySelector('.partners__btn');
		let splidePartners = new Splide( sliderPartners, {
			type: 'loop',
			arrows: false,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			autoplay: true,
			interval: 4000,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 4,
					perMove: 4,
				},
			}
		});
		splidePartners.mount();
		//attach events to custom buttons
		partnersBtnNext.addEventListener('click', e => {
			splidePartners.go('+1')
		});
	};

	// NEWS SLIDER
	let sliders = document.querySelectorAll('.splide-bzh');
	let sliderNews = document.querySelector('.splide-news');

	if (typeof sliders != 'undefined' && sliders != null) {
		for (let i=0;i<sliders.length;i++ ) {
			let slider = sliders[i];
			let splide = new Splide( slider );
			splide.mount();
		}
	};

	if (typeof sliderNews != 'undefined' && sliderNews != null) {
		let splideNews = new Splide( sliderNews, {
			type: 'loop',
			arrows: true,
			pagination: false,
			paginationDirection: 'ltr',
			perMove: 1,
			focus: 0,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			arrowPath: 'M 21.816406 1.277344 C 21.027344 1.277344 20.238281 1.578125 19.636719 2.179688 L 8 13.820312 C 6.792969 15.023438 6.792969 16.976562 8 18.179688 L 19.636719 29.820312 C 20.839844 31.023438 22.796875 31.023438 24 29.820312 L 24 29.816406 C 25.207031 28.613281 25.207031 26.660156 24 25.453125 L 14.546875 16 L 24 6.546875 C 25.207031 5.339844 25.207031 3.386719 24 2.183594 L 24 2.179688 C 23.398438 1.578125 22.609375 1.277344 21.816406 1.277344 Z M 21.816406 1.277344 ',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					destroy: true,
				},
			}
		});
		splideNews.mount();
	};

	// SINGLE NEWS SLIDER
	let singleNewsSlider = document.querySelector('.splide-single-news');

	if (typeof singleNewsSlider != 'undefined' && singleNewsSlider != null) {
		let singleNewsSplide = new Splide( singleNewsSlider, {
			type: 'loop',
			arrows: true,
			arrowPath: iconSvg,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			autoplay: true,
			interval: 4000,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				768: {
					perPage: 2,
					perMove: 2,
					gap: "20px"
				},
				1024: {
					perPage: 3,
					perMove: 3,
					gap: "40px"
				}
			}
		});
		singleNewsSplide.mount();
	};

	// CHRONO SLIDER
	let chrono = document.querySelector('.chrono');

	if (typeof(chrono) != 'undefined' && chrono != null) {

		// SET ACTIVE FUNCTION
		let setActive = (oldActives, newActive) => {
			oldActives.forEach((oldActive) => {
				if(oldActive.classList.contains('active')) {
					oldActive.classList.remove('active');
				}
				newActive.classList.add('active');
			});
		}

		// CHRONO NAV SLIDER + CHRONO SLIDER
		let navSlider = chrono.querySelector('.chrono__nav');
		let chronoSlider = chrono.querySelector('.chrono__slider');

		let navSplide = new Splide( navSlider, {
				pagination: false,
				arrowPath: iconSvg,
				type: 'loop',
				perMove: 1,
				isNavigation: true,
		} );

		let chronoSplide = new Splide( chronoSlider, {
				type: 'fade',
				pagination: false,
				arrowPath: iconSvg
		} );

		// SYNC & MOUNT SLIDERS
		chronoSplide.sync( navSplide );
		chronoSplide.mount();
		navSplide.mount();

		// CHRONO LIST
		let chronoBtns = chrono.querySelectorAll('.chrono__desktop__btn');
		for(let i=0;i<chronoBtns.length;i++) {
			let chronoBtn = chronoBtns[i];
			let chronoData = chronoBtn.dataset.index;
			chronoBtn.addEventListener('click', () => {
				chronoSplide.go(Number(chronoData));
			});
		}

		navSplide.on( 'move', function (newIndex, prevIndex, destIndex) {
			setActive(chronoBtns, chronoBtns[newIndex]);
		});	

	} // END OF chrono

}); //end of DOM Load

// Set icon for map
function SetIconImg(id, subId, choice1, choice2, choice3) {
	let icon;
	if (id == 2) {
		icon = choice1;
	} else if (id == 3) {
		icon = choice3;
	} else {
		icon = choice2;
	}

	return icon;
}

// Set icon size for map
function SetIconSize(id) {
	let iconSize = "";
	if (id == 2) {
		iconSize = [99, 55];
	} else {
		iconSize = [48, 70];
	}

	return iconSize;
}

// Leaflet Map
function initMap() {

	// MAP
	var mapCanvas = document.getElementById('bernard-map');

	if (typeof(mapCanvas) != 'undefined' && mapCanvas != null) {
		var map = L.map(mapCanvas).setView([48.17619081471445, -2.753472580093181], 13);

		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			minZoom: 9,
			maxZoom: 15,
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
		}).addTo(map);

		// set zoom after init
		map.setZoom(10);

		// PULL CONCESSION POST TYPE & ADD MARKERS
		const itemsContainer = document.querySelector('.js-concessions');

		if (typeof(itemsContainer) != 'undefined' && itemsContainer != null) {
			const postsShown = 100;
			let count = 0;
			let siteId = itemsContainer.getAttribute('data-id');
			let siteUrl = itemsContainer.getAttribute('data-site');
			let themeUrl = itemsContainer.getAttribute('data-theme');
			let logoEspaceAgri = themeUrl + '/assets/images/logo_espace_agri.png';
			let logoAgri = themeUrl + '/assets/images/logo_bernard_agriculture.png';
			let logoManu = themeUrl + '/assets/images/logo_bernard_manutention.png';
			let logoMoto = themeUrl + '/assets/images/logo_moto.png';
			let markerEspaceAgri = themeUrl + '/assets/images/marker_espace_agri.png';
			let markerManu = themeUrl + '/assets/images/marker_bernard_manutention.png';
			const arrayGroupe = [];
			const arrayEspaceAgri = [];
			const arrayManu = [];
			const jobsList = [];

			// Non-administrable addresses (last minute client request)
			const listAgri = [
				["Saint-Gilles", "Zac de la Forge <br/> 17 Avenue Jean-Baptiste Godin <br/> 35590 ST GILLES", "02 23 30 54 40", 48.15861488886493, -1.8299378134925526],
			];
			const listMoto = [
				["Saint-Gilles", "Zac de la Forge <br/> 17 Avenue Jean-Baptiste Godin <br/> 35590 ST GILLES", "02 23 30 54 50", 48.15861488886493, -1.8299378134925526],
				["Broons", "ZA du Pilaga <br/> 2 rue de l’avenir <br/> 22250 BROONS", "02 96 41 27 05", 48.31591770238342, -2.249247880955319 ],
				["Moréac", "Zone du Bronut <br/> 56500 MOREAC", "02 97 62 45 40", 47.897151406197544, -2.8377111283482845],
			];

			// Agri loop
			const arrayAgri = [];
			let listAgriMarkers = [];
			let iconAgri = L.icon({
				iconUrl: themeUrl + '/assets/images/marker_bernard_agriculture.png',
				iconSize: [48, 70], // size of the icon
				iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
			});
			for (let i=0;i<listAgri.length;i++) {
				let marker = L.marker([listAgri[i][3], listAgri[i][4]], {
					icon: iconAgri
				});
				listAgriMarkers.push(marker);
				const listItem = `<li class="map__item">
				<button type="button" class="map__btn" data-lat="${listAgri[i][3]}" data-lng="${listAgri[i][4]}">
					${listAgri[i][0]}
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconSvg}"></path></svg>
				</button>
				<div class="map__info">
					<div class="map__addr">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconMarker}"></path></svg>
						<p>${listAgri[i][1]}</p>
					</div>
					<div class="map__phone">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconPhone}"></path></svg>
						<p>${listAgri[i][2]}</p>
					</div>
				</div>
			</li>`;
			arrayAgri.push(listItem);
			}
			var listAgriLayer = new L.layerGroup(listAgriMarkers);

			// Moto loop
			const arrayMoto = [];
			let listMotoMarkers = [];
			let iconMoto = L.icon({
				iconUrl: themeUrl + '/assets/images/marker_bernard_motoculture.png',
				iconSize: [48, 70], // size of the icon
				iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
			});
			for (let i=0;i<listMoto.length;i++) {
				let marker = L.marker([listMoto[i][3], listMoto[i][4]], {
					icon: iconMoto
				});
				listMotoMarkers.push(marker);
				const listItem = `<li class="map__item">
				<button type="button" class="map__btn" data-lat="${listMoto[i][3]}" data-lng="${listMoto[i][4]}">
					${listMoto[i][0]}
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconSvg}"></path></svg>
				</button>
				<div class="map__info">
					<div class="map__addr">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconMarker}"></path></svg>
						<p>${listMoto[i][1]}</p>
					</div>
					<div class="map__phone">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconPhone}"></path></svg>
						<p>${listMoto[i][2]}</p>
					</div>
				</div>
			</li>`;
			arrayMoto.push(listItem);
			}
			var listMotoLayer = new L.layerGroup(listMotoMarkers);


			pullJobs(jobsList, siteUrl);

			let fetchAsync = async () => {
				const response = await fetch(siteUrl + `/wp-json/concession/all-posts`);
				if(response.ok == true) {
					fetchFunction();
				} else {
					console.log('oops, erreur !')
				};
			}

			let fetchFunction = () => {

				fetch(siteUrl + `/wp-json/concession/all-posts`)
					.then((response) => response.json())
					.then((data) => {
						const newData = chunkArray(data, postsShown);
						const currentChunk = newData[count];
						
						// Loop
						currentChunk.forEach((key, index) => {
							let site;
							let siteImg;
							let permalink;
							const postSite = currentChunk[index].site;
							const postEntity = currentChunk[index].entity;
							const postUrl = currentChunk[index].url;
							const postLat = currentChunk[index].latitude;
							const postLng = currentChunk[index].longitude;
							const postTitle = currentChunk[index].title;
							const postAddr = currentChunk[index].address;
							const postPhone = currentChunk[index].phone;
							const postSlug = currentChunk[index].slug;
							const postJobs = filterJobs(jobsList, postTitle, postEntity, postSite);
							
							const listItem = `<li class="map__item">
								<button type="button" class="map__btn" data-lat="${postLat}" data-lng="${postLng}">
									${postTitle}
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconSvg}"></path></svg>
								</button>
								<div class="map__info">
									<div class="map__addr">
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconMarker}"></path></svg>
										<p>${postAddr}</p>
									</div>
									<div class="map__phone">
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1"><path d="${iconPhone}"></path></svg>
										<p>${postPhone}</p>
									</div>
									<div class="map__jobs">
										${postJobs}
									</div>
								</div>
							</li>
							`;
							let markerImage = "";
							let slug = postUrl.slice(0, -1).lastIndexOf('/'); //remove trailing slash and get latest word (slug)
							slug = postUrl.substr(slug);

							// If site = espace agri or manu
							if ( String(postSite).includes("2") ) {
								if (siteId == 1 || siteId == 2) { // if in main site or espace agri
									site = "espace-agri";
									markerImage = logoEspaceAgri;
									arrayEspaceAgri.push(listItem);
								}
							} else if ( String(postSite).includes("3") ) {
								if (siteId == 1 || siteId == 3) { // if in main site or manu/agri
										site = "manu";
										markerImage = logoManu;
										arrayManu.push(listItem);
								}
							}

							// If site = main site and sub-category is Bernard Agriculture
							// if (siteId == 1 && postEntity == 'bernard-agriculture') {
							// if (siteId == 1 ) {
							// 	site = "agri";
							// 	markerImage = logoAgri;
							// 	arrayAgri.push(listItem);
							// }

							let greenIcon = L.icon({
								iconUrl: SetIconImg(postSite, postEntity, markerEspaceAgri, logoAgri, markerManu ),
								iconSize: SetIconSize(postSite), // size of the icon
								iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
							});

							if (siteId == 1 || (postSite == siteId && !postEntity)) {
								L.marker([postLat, postLng], {
									icon: greenIcon
								}).addTo(map);
							}

							if (siteId == 1) {
								listAgriLayer.addTo(map);
								listMotoLayer.addTo(map);
							}

							let contentString = `<div class="info-window">
							<h4>${postTitle}</h4>
								<div class="info-content">
									<p>${postAddr}</p>
									<p>${postPhone}</p>
								</div>
							</div>`;

						});

						if (arrayEspaceAgri.length > 0) {
						itemsContainer.insertAdjacentHTML("beforeend", `
							<figure class="map__figure map__figure--espace-agri">
								<img src="${logoEspaceAgri}">
								<figcaption>Nos concessions</figcaption>
							</figure>
							<ul class="map__list map__list--espace-agri">${arrayEspaceAgri.join("")}</ul>
						`);
						}
						if (arrayManu.length > 0 ) {
							itemsContainer.insertAdjacentHTML("beforeend", `
								<figure class="map__figure map__figure--manu">
									<img src="${logoManu}">
									<figcaption>Nos concessions</figcaption>
								</figure>
								<ul class="map__list map__list--manu">${arrayManu.join("")}</ul>
							`);
						}
						if (siteId == 1) {
							if (arrayAgri.length > 0) {
								itemsContainer.insertAdjacentHTML("beforeend", `
									<figure class="map__figure map__figure--agri">
										<img src="${logoAgri}">
										<figcaption>Nos concessions</figcaption>
									</figure>
									<ul class="map__list map__list--agri">${arrayAgri.join("")}</ul>
								`);
							}
							if (arrayMoto.length > 0) {
								itemsContainer.insertAdjacentHTML("beforeend", `
									<figure class="map__figure map__figure--moto">
										<img src="${logoMoto}">
										<figcaption>Nos concessions</figcaption>
									</figure>
									<ul class="map__list map__list--moto">${arrayMoto.join("")}</ul>
								`);
							}
						}
						count++;
				})
				.then(function() {

				// Initialize block data-attribute height
				let mapItems = document.querySelectorAll('.map__item');
				for(let i=0; i<mapItems.length; i++) {
					let mapInfo = mapItems[i].querySelector('.map__info');
					mapInfo.setAttribute("data-height", mapInfo.offsetHeight);
					mapInfo.style.maxHeight= "0px";
				}

				// Set buttons for map filter
				let buttons = document.querySelectorAll('.map__btn');

				let deactivateOtherItems = () => {
					buttons.forEach((el) => {
						el.classList.remove('active');
						el.nextElementSibling.style.maxHeight = "0px";
						} 
					);
				}
			
				for (let i=0; i<buttons.length; i++) {
					let button = buttons[i];
					button.addEventListener('click', () => {
						deactivateOtherItems();
						let lat = button.getAttribute('data-lat');
						let lng = button.getAttribute('data-lng');
						button.classList.add('active');
						button.nextElementSibling.style.maxHeight = button.nextElementSibling.dataset.height + "px"; // Get data-height attribute
						map.flyTo([lat, lng], 11, {
							animate: true,
							duration: 1.5
						});
					})
				}

				})
				.catch((err) => {
					console.log("Something went wrong!", err);
				});
			};

			fetchAsync();

		};

	};

}

function collapseSubMenu() {
	navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
	navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
}

// Fixed Resize Screen Function
window.addEventListener('resize', () => {
	if (window.innerWidth > 992) {
		// If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}

		// If menu-item-child is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
	}
});

// SCROLL-RELATED FUNCTIONS

/* Animate on scroll */
let scrollOffset = 100;
let scrollElements = document.querySelectorAll(".js-scroll");

//initialize throttleTimer as false
let timerOne, timerTwo, timerThree = false;
 
let throttle = function(callback, throttleTimer, time) {

    //don't run the function while throttle timer is true
    if (throttleTimer) return;
     
    //first set throttle timer to true so the function doesn't run
    throttleTimer = true;
     
    setTimeout(function() {
        //call the callback function in the setTimeout and set the throttle timer to false after the indicated time has passed 
        callback();
        throttleTimer = false;
    }, time);
}

var elementInView = function(el, offset) {
  var offset = 0;
  var elementTop = el.getBoundingClientRect().top;
 
  return (
    elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - offset)
  );
};

var elementOutofView = function(el) {
  var elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

var displayScrollElement = function(element) {
  element.classList.add("scrolled");
};

var hideScrollElement = function(element) {
  element.classList.remove("scrolled");
};
 
var handleScrollAnimation = function() {
  scrollElements.forEach(function(el) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

/* STEPS BAR */

let stepsBarHeight= () => {
	if (typeof(document.querySelector(".steps__bar")) != 'undefined' && document.querySelector(".steps__bar") != null) {

	let stepButtons = document.querySelectorAll(".steps__btn");

	for(let i = 0; i < stepButtons.length; i++ ) {
		stepButtons[i].addEventListener("click", (e) => {
			let stepButton = stepButtons[i];
			stepButton.parentNode.classList.toggle('active');
		});
	}
	
	let stepBlocks = document.querySelectorAll(".steps__block");
	let stepBlocksLength = stepBlocks.length;

	let stepBar = document.querySelector(".steps__bar");
	let stepBarInner = document.querySelector(".steps__bar__inner");
	let stepBarHeight = stepBar.parentNode.offsetHeight - (stepBar.parentNode.offsetHeight / stepBlocksLength);
	let stepBarTop = stepBar.getBoundingClientRect().top;
	// let stepBarBottom = stepBarTop + stepBarHeight;

	stepBar.style.height = stepBarHeight + "px";

	let scrollStep = () => {
		let top  = window.pageYOffset || document.documentElement.scrollTop;
		let trigger = Math.round(top + window.innerHeight);
		let stepBarProgress = Math.round((window.pageYOffset + (window.innerHeight / 2) - stepBarTop));
		if (trigger > stepBarTop) {
			stepBarInner.style.height = stepBarProgress + "px";
		}
	}

	window.addEventListener('scroll', function() {
		throttle(scrollStep, false, 100);
	});

	};
}

stepsBarHeight();

let resizeSteps = debounce(function() {
	stepsBarHeight();
}, 250);

window.addEventListener("resize", resizeSteps);

/* Sticky menu */
let header = document.querySelector(".header");
let headerHeight = header.offsetHeight;
let flag = false;
let sticker = document.querySelector(".sticker");

let stickyMenu = () => {
	var posCurseur = window.scrollY;

	if(posCurseur < headerHeight){
		header.classList.remove('sticky');
		header.classList.remove('invisible');
		flag = false;
	} else if(posCurseur > headerHeight) {
		if (flag == false) {
			header.classList.add('invisible');
			setTimeout(() => {
				header.classList.add('sticky');
			}, 300);
			flag = true;
		} else {
			setTimeout(() => {
			header.classList.remove('invisible');
		}, 300);
		}
	}
}

/* Sticker */
let stickerMove = () => {
	if (typeof(sticker) != 'undefined' && sticker != null) {

		setTimeout(() => {
			sticker.classList.add('animated');
		}, 300);
		sticker.classList.remove('animated');

		if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
			sticker.classList.add("invisible");
			setTimeout(() => {
				sticker.classList.add('deleted');
			}, 300);
		} else {
			sticker.classList.remove('deleted');
			setTimeout(() => {
				sticker.classList.remove('invisible');
			}, 300);
		}
	};

}
 
window.addEventListener('scroll', function() {
	throttle(stickyMenu, timerOne, 250);
	throttle(stickerMove, timerTwo, 250);
  throttle(handleScrollAnimation, timerThree, 250);
})

/* Smooth Scroll */
/* https://github.com/cferdinandi/smooth-scroll */
new SmoothScroll('a[href*="#"]:not(a[href*="#tarteaucitron"])', {
	speed: 1000,
	speedAsDuration: true,
	easing: 'easeInOutQuart'
});

/* Dynamic Job offers using Wordpress Rest API  */
/* https://daltonwalsh.com/blog/dynamically-load-more-in-wordpress-with-js/ */
function chunkArray(array, size) {
  const chunkyArr = [];
  let index = 0;
	if (array.length < size) {
    chunkyArr.push(array);
  } else {
		while (index < array.length) {
			chunkyArr.push(array.slice(index, size + index));
			index += size;
		}
	}

  return chunkyArr;
}

let pullJobs = (arr, url) => {
	let siteUrl = url;
	fetch(siteUrl + `/wp-json/awsm_job_openings/all-posts`)
		.then((response) => response.json())
		.then((data) => {
			let count = 0;
			const newData = chunkArray(data, data.length);
			const currentChunk = newData[count];
			// Creates an array of "offres d'emploi" length, and pushes infos such as address, title, slug etc...
			Array.apply(arr, Array(data.length));
			for(let i=0; i<data.length; i++) {
				let subArray = [];
				subArray[0] = currentChunk[i].site; // Site ID
				// subArray[1] = currentChunk[i].address[0].name; // City
				subArray[2] = currentChunk[i].slug; // Slug
				subArray[3] = currentChunk[i].title; // Offer title
				subArray[4] = currentChunk[i].taxo; // Extra info
				arr.push(subArray);
			}
		});
};

// Get nth element of array (useful for the function below)
const getArrElement = (el, n = 0) => (n === -1 ? el.slice(n) : el.slice(n, n + 1))[0];

let filterJobs = (arr, location, entity, site) => {

	// console.log(location +  " " + entity + " " + site);

	let singularOrPlural = (num) => {
		if (num == 0 || num == 1 ) {
			return "offre d'emploi";
		} else {
			return "offres d'emploi";
		}
	}

	let counter = 0;
	let offer = "";

	for (let i=0;i<arr.length;i++) {

		let arrSite = arr[i][0].toString();
		let arrSlug = arr[i][2];
		let arrTitle = arr[i][3];

		// If location, site and entity corresponds, display "offres d'emploi" posts
		let arrTaxo = Object.entries(arr[i][4]); // Convert raw data to array for whatever reason
		let jobType = getArrElement(arrTaxo, 1)[1];
		let jobLocation = getArrElement(arrTaxo, 2)[1];
		// let jobEntity = getArrElement(arrTaxo, 3)[1];
		site = site.toString();
		// console.log('offer : ' + i );
		// console.log('entity : ' + entity );
		// console.log('jobEntity : ' + jobEntity );
		// console.log('arrSite : ' + arrSite );
		// console.log('site : ' + site );
		// console.log('location : ' + location );
		// console.log('jobLocation : ' + jobLocation );
		// console.log(arrTitle);

		if(arrSite.includes(site) && jobLocation.includes(location) ) { // Corresponding site/location
			// if(jobEntity.includes(entity) || jobEntity == "") { // Corresponding entity
				counter++;
				offer += `<p class="map__jobs__offer"><a href="${getSiteUrl(arrSite)}emploi/${arrSlug}">${arrTitle}</a></p>`
			// }
		}
	}
	let result = `<p class="map__jobs__title">${counter} ${singularOrPlural(counter)}</p>` + offer;
	return result;

}
